import { render, staticRenderFns } from "./Helpneeds.vue?vue&type=template&id=1ed2769f"
import script from "./Helpneeds.vue?vue&type=script&lang=js"
export * from "./Helpneeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports